import { GET, PATCH, POST } from "../../helper/official_website_restfunctions";

export const get_all_applicant_list = async () => {
  const path = `/join_us_page`;
  return await GET(path)
    .then((result) => {
      return result[1];
    })
    .catch((err) => {
      console.log("error on fetching objective >", err);
      return err;
    });
};